import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from './components/nuxt-error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_sentryserver_1b2147ce from 'nuxt_plugin_sentryserver_1b2147ce' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_e6942ade from 'nuxt_plugin_sentryclient_e6942ade' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_templatesplugin3bb4765a_25fc9a59 from 'nuxt_plugin_templatesplugin3bb4765a_25fc9a59' // Source: ./templates.plugin.3bb4765a.js (mode: 'client')
import nuxt_plugin_localforage_1fed0fac from 'nuxt_plugin_localforage_1fed0fac' // Source: ./localforage.js (mode: 'client')
import nuxt_plugin_googlegtag_43734778 from 'nuxt_plugin_googlegtag_43734778' // Source: ./google-gtag.js (mode: 'client')
import nuxt_plugin_axios_dad47d56 from 'nuxt_plugin_axios_dad47d56' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_vuestripe_03930b4d from 'nuxt_plugin_vuestripe_03930b4d' // Source: ../plugins/vue-stripe.js (mode: 'client')
import nuxt_plugin_axios_3566aa80 from 'nuxt_plugin_axios_3566aa80' // Source: ../plugins/axios (mode: 'client')
import nuxt_plugin_vmask_3801a64e from 'nuxt_plugin_vmask_3801a64e' // Source: ../plugins/v-mask (mode: 'client')
import nuxt_plugin_vfocus_c8ec26ea from 'nuxt_plugin_vfocus_c8ec26ea' // Source: ../plugins/v-focus (mode: 'client')
import nuxt_plugin_veevalidate_6e5ad03a from 'nuxt_plugin_veevalidate_6e5ad03a' // Source: ../plugins/vee-validate (mode: 'all')
import nuxt_plugin_vue2timepicker_14268066 from 'nuxt_plugin_vue2timepicker_14268066' // Source: ../plugins/vue2-timepicker (mode: 'client')
import nuxt_plugin_vuedatetime_52833350 from 'nuxt_plugin_vuedatetime_52833350' // Source: ../plugins/vue-datetime (mode: 'client')
import nuxt_plugin_vuemixpanel_2c40a805 from 'nuxt_plugin_vuemixpanel_2c40a805' // Source: ../plugins/vue-mixpanel (mode: 'client')
import nuxt_plugin_taginput_d2e60dbe from 'nuxt_plugin_taginput_d2e60dbe' // Source: ../plugins/tag-input (mode: 'client')
import nuxt_plugin_vuecrypto_418aa244 from 'nuxt_plugin_vuecrypto_418aa244' // Source: ../plugins/vue-crypto (mode: 'client')
import nuxt_plugin_vuenotifications_9509a7aa from 'nuxt_plugin_vuenotifications_9509a7aa' // Source: ../plugins/vue-notifications (mode: 'client')
import nuxt_plugin_vuetify_165b1c58 from 'nuxt_plugin_vuetify_165b1c58' // Source: ../plugins/vuetify (mode: 'client')
import nuxt_plugin_vuephonenumberinput_515010e2 from 'nuxt_plugin_vuephonenumberinput_515010e2' // Source: ../plugins/vue-phone-number-input (mode: 'client')
import nuxt_plugin_vuecharts_42ba3b1c from 'nuxt_plugin_vuecharts_42ba3b1c' // Source: ../plugins/vue-charts (mode: 'client')
import nuxt_plugin_loadscript_55b1865c from 'nuxt_plugin_loadscript_55b1865c' // Source: ../plugins/load-script (mode: 'client')
import nuxt_plugin_vuetour_9db5e896 from 'nuxt_plugin_vuetour_9db5e896' // Source: ../plugins/vue-tour (mode: 'client')
import nuxt_plugin_vuezoomer_064b45dd from 'nuxt_plugin_vuezoomer_064b45dd' // Source: ../plugins/vue-zoomer (mode: 'client')
import nuxt_plugin_vueimageinput_bce81e4a from 'nuxt_plugin_vueimageinput_bce81e4a' // Source: ../plugins/vue-image-input (mode: 'client')
import nuxt_plugin_vuechatemoji_24baad2e from 'nuxt_plugin_vuechatemoji_24baad2e' // Source: ../plugins/vue-chat-emoji (mode: 'client')
import nuxt_plugin_vuetelinput_44ffc74a from 'nuxt_plugin_vuetelinput_44ffc74a' // Source: ../plugins/vue-tel-input (mode: 'client')
import nuxt_plugin_plugin_6e39bad1 from 'nuxt_plugin_plugin_6e39bad1' // Source: ./auth/plugin.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Clickzap","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"robots","content":"noindex"},{"hid":"description","name":"description","content":"Clickzap"},{"name":"google","content":"notranslate"}],"link":[{"rel":"preconnect","href":"https:\u002F\u002Ffonts.googleapis.com"},{"rel":"preconnect","href":"https:\u002F\u002Ffonts.gstatic.com","crossorigin":true},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Montserrat:wght@300;400;500;600;700&display=swap"},{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"stylesheet","href":"\u002Fassets\u002Flibs\u002Fbootstrap-grid.min.css"},{"rel":"stylesheet","href":"https:\u002F\u002Fuse.fontawesome.com\u002Freleases\u002Fv6.4.0\u002Fcss\u002Fall.css"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Roboto:300,400,500,700|Material+Icons"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Rubik:400,500,700,900&display=swap"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Anton&display=swap"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.cdnfonts.com\u002Fcss\u002Finter"},{"rel":"stylesheet","href":"\u002Fassets\u002Flibs\u002Fdevices.min.css"},{"rel":"stylesheet","href":"https:\u002F\u002Fcdnjs.cloudflare.com\u002Fajax\u002Flibs\u002Fmaterial-design-iconic-font\u002F2.1.2\u002Fcss\u002Fmaterial-design-iconic-font.min.css"}],"script":[{"src":"https:\u002F\u002Fcheckout.pagar.me\u002Fv1\u002Ftokenizecard.js","data-pagarmecheckout-app-id":"pk_Pgqw15ud1IPGwoK0","async":true,"defer":true},{"src":"\u002Fassets\u002Flibs\u002Fpaho-mqtt-min.js","async":true,"defer":true},{"src":"https:\u002F\u002Fjs.stripe.com\u002Fv3"},{"src":"https:\u002F\u002Fwww.googletagmanager.com\u002Fgtag\u002Fjs?id=AW-705621211","async":true}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.server && typeof nuxt_plugin_sentryserver_1b2147ce === 'function') {
    await nuxt_plugin_sentryserver_1b2147ce(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_e6942ade === 'function') {
    await nuxt_plugin_sentryclient_e6942ade(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_templatesplugin3bb4765a_25fc9a59 === 'function') {
    await nuxt_plugin_templatesplugin3bb4765a_25fc9a59(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_localforage_1fed0fac === 'function') {
    await nuxt_plugin_localforage_1fed0fac(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googlegtag_43734778 === 'function') {
    await nuxt_plugin_googlegtag_43734778(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_dad47d56 === 'function') {
    await nuxt_plugin_axios_dad47d56(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuestripe_03930b4d === 'function') {
    await nuxt_plugin_vuestripe_03930b4d(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_axios_3566aa80 === 'function') {
    await nuxt_plugin_axios_3566aa80(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vmask_3801a64e === 'function') {
    await nuxt_plugin_vmask_3801a64e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vfocus_c8ec26ea === 'function') {
    await nuxt_plugin_vfocus_c8ec26ea(app.context, inject)
  }

  if (typeof nuxt_plugin_veevalidate_6e5ad03a === 'function') {
    await nuxt_plugin_veevalidate_6e5ad03a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vue2timepicker_14268066 === 'function') {
    await nuxt_plugin_vue2timepicker_14268066(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuedatetime_52833350 === 'function') {
    await nuxt_plugin_vuedatetime_52833350(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuemixpanel_2c40a805 === 'function') {
    await nuxt_plugin_vuemixpanel_2c40a805(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_taginput_d2e60dbe === 'function') {
    await nuxt_plugin_taginput_d2e60dbe(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuecrypto_418aa244 === 'function') {
    await nuxt_plugin_vuecrypto_418aa244(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuenotifications_9509a7aa === 'function') {
    await nuxt_plugin_vuenotifications_9509a7aa(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuetify_165b1c58 === 'function') {
    await nuxt_plugin_vuetify_165b1c58(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuephonenumberinput_515010e2 === 'function') {
    await nuxt_plugin_vuephonenumberinput_515010e2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuecharts_42ba3b1c === 'function') {
    await nuxt_plugin_vuecharts_42ba3b1c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_loadscript_55b1865c === 'function') {
    await nuxt_plugin_loadscript_55b1865c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuetour_9db5e896 === 'function') {
    await nuxt_plugin_vuetour_9db5e896(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuezoomer_064b45dd === 'function') {
    await nuxt_plugin_vuezoomer_064b45dd(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueimageinput_bce81e4a === 'function') {
    await nuxt_plugin_vueimageinput_bce81e4a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuechatemoji_24baad2e === 'function') {
    await nuxt_plugin_vuechatemoji_24baad2e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuetelinput_44ffc74a === 'function') {
    await nuxt_plugin_vuetelinput_44ffc74a(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_6e39bad1 === 'function') {
    await nuxt_plugin_plugin_6e39bad1(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
